import { TaskGroupBy } from "@common/types/task";
import { TaskListQuery } from "@common/contracts/task.contract";

export const resolveTaskListEntityIds = ({
    selectedEntityIds,
    availableEntityIds,
}: {
    selectedEntityIds: number[] | undefined;
    availableEntityIds: number[] | undefined;
}): number[] | undefined => {
    if (availableEntityIds == null) {
        return selectedEntityIds;
    }

    if (!selectedEntityIds?.length) {
        return undefined;
    }

    const validIds = selectedEntityIds.filter((entityId) =>
        availableEntityIds.includes(entityId),
    );

    if (validIds.length === selectedEntityIds.length) {
        return selectedEntityIds;
    }

    return validIds.length > 0 ? validIds : undefined;
};

export const applyTaskListDrillDownFilters = ({
    prev,
    closeId,
    entityId,
    groupBy,
}: {
    prev: TaskListQuery;
    closeId?: string | null;
    entityId?: number | null;
    groupBy?: TaskGroupBy;
}): TaskListQuery => {
    const isValidEntityId = entityId != null && entityId > 0;
    const next: TaskListQuery = { ...prev };

    if (closeId) {
        next.groupBy = TaskGroupBy.CLOSE_STAGE;
    } else if (groupBy) {
        next.groupBy = groupBy;
    }

    if (isValidEntityId) {
        next.entityIds = [entityId];
    } else if (closeId) {
        next.entityIds = undefined;
    }

    return next;
};
